import { Directive } from '@angular/core';
import { DragAndDropManagerService } from './drag-and-drop-manager.service';
import { DragAndDropManagerDirective } from '@core/modules/drag-and-drop-manager/drag-and-drop-manager.directive';

@Directive({
    selector: '[dragAndDropManagerRoot]',
    providers: [
        {
            provide: DragAndDropManagerService
        }
    ],
    standalone: false
})
export class DragAndDropManagerRootDirective extends DragAndDropManagerDirective {}
